import { getAuthPageCopy } from '@/i18n/auth-page-copy';
import {
  handleAuthError,
  type AuthErrorResult,
} from '@/lib/auth-error-handler';

export function handleLocalizedAuthError(
  error: unknown,
  locale: string
): AuthErrorResult {
  const copy = getAuthPageCopy(locale);

  return handleAuthError(error, {
    emailNotVerified: copy.pleaseVerifyEmail,
    invalidCredentials: copy.invalidCredentials,
    invalidPassword: copy.invalidPasswordTryAgain,
    invalidVerificationCode: copy.invalidVerificationCode,
    verificationCodeExpired: copy.verificationCodeExpired,
  });
}
